import {
  CfHeaderMenuProps,
  HeaderMenuItemSchema,
  PrivateAreaSchema,
  headerMenuSchema,
} from "components/HeaderNew/HeaderFull/CfHeaderMenuFull/schema";
import { ContentfulHeaderFullLiveData } from "components/HeaderNew/HeaderFull/CfHeaderMenuFull/types";
import { HeaderFullDataProps } from "components/HeaderNew/HeaderFull/types";
import { assert } from "superstruct";
import { convertMenu, convertSettings } from "components/HeaderNew/utils";
import { getTranslations } from "helpers/contenful";

export const normalizeCfJsonData = (
  jsonData?: ContentfulHeaderFullLiveData,
) => {
  if (!jsonData) return undefined;

  return {
    menu:
      "internal" in jsonData.navigation.menuTree
        ? (JSON.parse(jsonData.navigation.menuTree.internal.content)
            .menu as HeaderMenuItemSchema[])
        : jsonData.navigation.menuTree.menu,
    menuIdentifiers: {
      __typename: jsonData.navigation.__typename,
      contentful_id: jsonData.navigation.contentful_id,
    },
    settings: {
      logo: {
        image: {
          src: jsonData.logo.file.url,
          alt: jsonData.logo.description,
        },
        ctaAnchor: jsonData.linkLogo
          ? {
              href: jsonData.linkLogo,
              blank: false,
            }
          : null,
      },
      translations: getTranslations(jsonData.translations),
      ...(jsonData.defaultPageSearch
        ? {
            search: {
              slug: jsonData.defaultPageSearch[0].slug,
              templateSlug: jsonData.defaultPageSearch[0].templateSlug,
              text:
                typeof jsonData.textSearch === "string"
                  ? jsonData.textSearch
                  : jsonData.textSearch?.textSearch,
            },
          }
        : {}),
      privateArea:
        "internal" in jsonData.settings
          ? (JSON.parse(jsonData.settings.internal.content)
              .privateArea as PrivateAreaSchema)
          : jsonData.settings.privateArea,
    },
    __typename: jsonData.__typename,
    contentful_id: jsonData.contentful_id,
  };
};

export const convertCfHeaderMenuProps = ({
  menu: { dataJson },
}: CfHeaderMenuProps) => {
  if (process.env.GATSBY_ENV !== "production") {
    try {
      assert(dataJson, headerMenuSchema);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.warn("validation HeaderFull", error);
    }
  }

  const { menu, settings } = dataJson;

  const props: HeaderFullDataProps = {
    __typename: dataJson.__typename,
    contentful_id: dataJson.contentful_id,
    menu: convertMenu(menu),
    settings: convertSettings(settings),
  };

  return props;
};
